export * from './oneZeroNineFourDataUpload.component';



// WEBPACK FOOTER //
// ./src/app/OneZeroNineFourDataUpload/index.ts